import { useCallback, useEffect, useRef, useState } from 'react';
import './style.css';
import { Price, Tag, Button } from '@chatui/core';

interface ProductCardType {
  name: string;
  desc: string;
  img: string;
  price: number;
  url?: string;
  tags?: string[];
  currency?: string;
}
const ProductCard = (props: ProductCardType) => {
  const { name, desc, img, price, url, tags, currency } = props;
  const descRef = useRef<HTMLDivElement>(null);
  const [isTruncate, setIsTruncate] = useState(false);
  const [showToggleButton, setShowToggleButton] = useState(false);

  useEffect(() => {
    if (descRef.current) {
      const descEl = descRef.current;
      const descHeight = descEl.clientHeight;
      if (descHeight > 42) {
        descEl.classList.add('truncate');
        setIsTruncate(true);
        setShowToggleButton(true);
      }
    }
  }, []);

  const toggleTruncate = useCallback(() => {
    if (descRef.current) {
      const descEl = descRef.current;
      descEl.classList.toggle('truncate');
      setIsTruncate(!isTruncate);
    }
  }, [isTruncate]);

  return (
    <div className="cust-product-card">
      <div className="Flex Goods">
        <div className="product-left">
          <img className="Goods-img" src={img} alt="" />
          <div>
            <div>
              <Price price={price} currency={currency} />
            </div>
            {url && (
              <button
                className="Btn Goods-detailBtn"
                type="button"
                onClick={() => {
                  window.open(url, '_blank');
                }}
              >
                View
              </button>
            )}
          </div>
        </div>

        <div className="FlexItem Goods-main">
          <h4 className="Text--ellipsis Goods-name">{name}</h4>
          {tags && tags.length > 0 && (
            <div className="Goods-tags">
              {tags.map((t, i) => (
                <Tag className="Tag--primary" key={i}>
                  {t}
                </Tag>
              ))}
            </div>
          )}
          <div className="Goods-desc" ref={descRef}>
            {desc}
          </div>
          {showToggleButton && (
            <Button
              variant="text"
              onClick={toggleTruncate}
              className="btn-toggle-truncate"
            >
              Show
              {isTruncate ? ' more' : ' less'}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
